export default __webpack_public_path__ + "media/music/55be8a5cd0923778eba6d5bb8471f07d.mp3";